import { useRouter } from "next/router";
import { useForm } from "react-hook-form";
import { useTranslation } from "next-i18next";
import React, { useEffect, useRef, RefObject } from "react";

import api from "helpers/api";
import { User$ } from "types/user";
import {
    InputType,
    emailPattern,
    Next,
    sendotp,
    sendOTP,
} from "helpers/auth.utils";

interface Props {
    user: User$;
}
export function ProfileInputs({ user }: Props): JSX.Element {
    const router = useRouter();
    const { t } = useTranslation();

    async function submit({ email, phone }: any, ref: any): Promise<void> {
        const input = email || `+98${phone}`;
        await sendOTP(input, Next.Profile, ref);
        router.push(
            {
                pathname: "/auth/verify/[input]",
                query: { input, next: Next.Profile },
            },
            "/profile/verify"
        );
    }

    useEffect(() => () => api.remove(`post:${sendotp[Next.Profile]}`), []);

    return (
        <div className="row px-3 px-lg-0">
            <div className="col-lg-6">
                <h3 className="d-none d-lg-block mb-5 profemail">
                    {t("common:form.email")}
                </h3>
                <ProfileEmail {...{ user, submit }} />
            </div>
            <div className="col-lg-6">
                <h3 className="d-none d-lg-block mb-5 profmobile">
                    {t("common:form.mobile")}
                </h3>
                <ProfilePhone {...{ user, submit }} />
            </div>
        </div>
    );
}

interface ChildProps extends Props {
    submit: (
        body: { [key in InputType]?: string },
        ref: RefObject<HTMLButtonElement>
    ) => void;
}

function ProfileEmail({ user, submit }: ChildProps): JSX.Element {
    const { t } = useTranslation();
    const { register, handleSubmit, formState, watch, reset } = useForm({
        mode: "all",
    });
    const { isDirty, isValid } = formState;
    const value = watch("email", user?.email);
    const submitBtn = useRef<HTMLButtonElement>(null);
    useEffect(() => {
        user && reset({ email: user.email });
    }, [user]);
    return (
        <form
            className="userName userEmail d-flex mb-3 mb-lg-0"
            onSubmit={handleSubmit((form) => submit(form, submitBtn))}
        >
            <input
                className="active"
                type="search"
                disabled={!!user?.email}
                {...register("email", {
                    pattern: emailPattern,
                    required: true,
                })}
                placeholder={t("common:form.emailplace")}
            />
            <label htmlFor="">{t("common:form.email")}</label>
            {/* {JSON.stringify(errors, null, 2)} */}
            {isDirty && value && isValid && (
                <button className="btn btn-primary" ref={submitBtn}>
                    {t("common:confirm")}
                </button>
            )}
            {/* <span className="clearfield" >
        <span className="icon icon-close"></span>
      </span> */}
        </form>
    );
}

function ProfilePhone({ user, submit }: ChildProps): JSX.Element {
    const { register, handleSubmit, formState, watch, reset } = useForm({
        mode: "all",
    });
    const { isDirty, isValid } = formState;
    const value = watch("phone");
    const submitBtn = useRef<HTMLButtonElement>(null);
    useEffect(() => {
        user && reset({ phone: user.phone });
    }, [user]);
    const { t } = useTranslation();
    return (
        <div className="my-3 mb-lg-0">
            <div className="d-flex align-items-center" dir="ltr">
                {/* <span className="area-code d-flex align-items-center">+98</span> */}
                <form
                    className="userName Usermobile d-flex flex-grow-1"
                    onSubmit={handleSubmit((form) => submit(form, submitBtn))}
                >
                    <input
                        className="active"
                        type="search"
                        disabled={!!user?.phone}
                        {...register("phone", {
                            pattern: /^9[0-9]{9}$/,
                            required: true,
                        })}
                        placeholder={t("common:form.phoneplace")}
                        maxLength={13}
                    />
                    <label htmlFor="">{t("common:form.mobile")}</label>
                    {value && isValid && (
                        <button className="btn btn-primary" ref={submitBtn}>
                            {t("common:confirm")}
                        </button>
                    )}
                    {/* <span className="clearfield" >
            <span className="icon icon-close"></span>
          </span> */}
                </form>
            </div>
        </div>
    );
}

export default React.memo(ProfileInputs);
